"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function default_1(number, index) {
    return [
        ['fa un moment', "d'aquí un moment"],
        ['fa %s segons', "d'aquí %s segons"],
        ['fa 1 minut', "d'aquí 1 minut"],
        ['fa %s minuts', "d'aquí %s minuts"],
        ['fa 1 hora', "d'aquí 1 hora"],
        ['fa %s hores', "d'aquí %s hores"],
        ['fa 1 dia', "d'aquí 1 dia"],
        ['fa %s dies', "d'aquí %s dies"],
        ['fa 1 setmana', "d'aquí 1 setmana"],
        ['fa %s setmanes', "d'aquí %s setmanes"],
        ['fa 1 mes', "d'aquí 1 mes"],
        ['fa %s mesos', "d'aquí %s mesos"],
        ['fa 1 any', "d'aquí 1 any"],
        ['fa %s anys', "d'aquí %s anys"],
    ][index];
}
exports.default = default_1;
//# sourceMappingURL=ca.js.map